import React from 'react';
import styles from '../cms.module.scss';

export const TitleBody = ({ value: { title, body: __html } }) => (
  <div className={styles['cms-rte']}>
    <h3 className={styles['cms-rte__title']}>{title}</h3>
    <div
      className={styles['cms-rte__body']}
      dangerouslySetInnerHTML={{ __html }} // eslint-disable-line react/no-danger
    />
  </div>
);

export default TitleBody;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/TitleBody/index.js